var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveNature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3C4.23858 3 2 5.23858 2 8C2 14.9241 7.53353 18.5003 11.0385 20.4681C11.6358 20.8034 12.3642 20.8034 12.9615 20.4681C16.4665 18.5003 22 14.9241 22 8C22 5.23858 19.7614 3 17 3C14.581 3 12.4633 4.71776 12 7C11.5367 4.71776 9.41896 3 7 3ZM15.319 11.3603C15.319 12.9549 14.2218 14.2901 12.7501 14.6343V13.859L13.6643 13.242C14.0076 13.0102 14.0981 12.5441 13.8664 12.2007C13.6347 11.8574 13.1685 11.7669 12.8252 11.9986L12.7501 12.0493V11.3602C12.7501 10.946 12.4143 10.6102 12.0001 10.6102C11.5858 10.6102 11.2501 10.946 11.2501 11.3602V12.0493L11.1749 11.9986C10.8316 11.7669 10.3654 11.8574 10.1337 12.2007C9.90199 12.5441 9.99247 13.0102 10.3358 13.242L11.2501 13.859V14.6344C9.77805 14.2903 8.68066 12.955 8.68066 11.3603C8.68066 9.50444 10.1667 8 11.9998 8C13.8329 8 15.319 9.50444 15.319 11.3603ZM11.2501 14.6344C11.491 14.6908 11.742 14.7205 11.9998 14.7205C12.2578 14.7205 12.509 14.6907 12.7501 14.6343V17.2407C12.7501 17.6549 12.4143 17.9907 12.0001 17.9907C11.5858 17.9907 11.2501 17.6549 11.2501 17.2407V14.6344Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveNature);
export default __webpack_public_path__ + "static/media/love-nature.5a47f5ba6703260a8d63057a3ec6d0df.svg";
export { ForwardRef as ReactComponent };